module.exports = __webpack_public_path__ + "img/ic_nav_music-off.db59b0d6.svg";